import styled from 'styled-components';

export const Container = styled.div`
  padding-left: 250px;
`;

export const ContentContainer = styled.main`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
`;
